const DEFAULT_BASE_DOMAIN =
  process.env.REACT_APP_SALON_BASE_DOMAIN || "salonium.pro"

const LOCAL_DEV_HOSTS = new Set(["localhost", "127.0.0.1"])

export function getSalonBaseDomain() {
  return DEFAULT_BASE_DOMAIN
}

export function isMainSiteHost(hostname = window.location.hostname) {
  if (LOCAL_DEV_HOSTS.has(hostname)) return true
  const base = DEFAULT_BASE_DOMAIN
  return hostname === base || hostname === `www.${base}`
}

/** Salon slug from subdomain, e.g. timeless-beauty.salonium.pro → timeless-beauty */
export function getSalonSlug(hostname = window.location.hostname) {
  if (typeof hostname !== "string" || !hostname) return null
  if (LOCAL_DEV_HOSTS.has(hostname)) return null

  if (hostname.endsWith(".localhost")) {
    const sub = hostname.slice(0, -".localhost".length)
    return sub && sub !== "www" ? sub : null
  }

  const base = DEFAULT_BASE_DOMAIN
  if (hostname === base || hostname === `www.${base}`) return null

  if (hostname.endsWith(`.${base}`)) {
    const sub = hostname.slice(0, -(base.length + 1))
    if (!sub || sub === "www") return null
    return sub
  }

  return null
}

export function isSalonSubdomain(hostname) {
  return Boolean(getSalonSlug(hostname))
}
